import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const RemoveTag = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line
  <svg viewBox="0 0 36 36" {...props}>
    <path d="M36 28.768l-10.768-10.768 10.768-10.768-7.232-7.232-10.768 10.768-10.768-10.768-7.232 7.232 10.768 10.768-10.768 10.768 7.232 7.232 10.768-10.768 10.768 10.768 7.232-7.232z" />
  </svg>
);

const StyledRemoveTag = styled(RemoveTag)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;
export default StyledRemoveTag;
